<div class="header-bar">
    <div class="header-left"></div>
    <div class="header-center">
        CorE™ Email Content Engine
    </div>
    <div class="header-right">
    </div>
</div>
<div class="completion-container">
    <div class="container form-container">
        <form [formGroup]="form">

            <div>
                <lhpe-input
                    class="input"
                    controlName="name"
                    placeholder="Email Name"
                    [formGroup]="form!"
                    [required]="true"
                >
                </lhpe-input>
            </div>

            <div>
                Briefly describe the purpose of the email so the CorE knows what to write. For example “This is a marketing email to encourage players to visit the property in the next week.”  
            </div>

            <div>
                <lhpe-textarea
                    class="input"
                    controlName="prompt"
                    placeholder="Email Description"
                    [formGroup]="form!"
                    [rows]="5"
                    [required]="true"
                >
                </lhpe-textarea>
            </div>

            <div>
                <mat-radio-group aria-label="Select an option" [value]="form.controls.generateSubject.value" formControlName="generateSubject" (change)="generateSubjectChange($event)">
                    <mat-label>Generate personalized subject line for each recipient?</mat-label>
                    <mat-radio-button class="mat-lightGreen" value="yes">Yes</mat-radio-button>
                    <mat-radio-button class="mat-lightGreen" value="no">No</mat-radio-button>
                </mat-radio-group>
            </div>

            <div *ngIf="form.controls.generateSubject.value === 'no'">
                <lhpe-input
                    class="input"
                    controlName="subject"
                    placeholder="Email Subject"
                    [formGroup]="form!"
                >
                </lhpe-input>
            </div>

            <div *ngIf="form.controls.generateSubject.value === 'yes'">
                <div class="instruct">
                    Select which profile trait to feature in the subject line (choose one): 
                </div>
                <lhpe-select
                    controlName="subjectField"
                    placeholder="Choose One"
                    [formGroup]="form!"
                    [required]="true"
                    [options]="fields"
                    optionValue="id"
                    [multiple]="false"
                    (change)="subjectFieldChange($event)"
                >
                </lhpe-select>
            </div>

            <div>
                <div class="instruct" *ngIf="form.controls.generateSubject.value === 'no'">
                    Select which profile traits to include in the body of the email (three max): 
                </div>
                <div class="instruct" *ngIf="form.controls.generateSubject.value === 'yes'">
                    Select which profile traits to include in the body of the email (two additional max): 
                </div>
                <mat-chip-list>
                    <mat-chip *ngFor="let field of fields" (click)="bodyFieldClick(field.id)" [ngClass]="{ 'active-chip': highlightBodyField(field.id) }">
                        {{field.name}}
                        <mat-icon matChipRemove *ngIf="removableBodyField(field.id)" (click)="removeBodyField(field.id)">cancel</mat-icon>
                    </mat-chip>
                </mat-chip-list>
            </div>

            <div class="divider-container">
                <mat-divider></mat-divider>
            </div>

            <div class="button-container">
                <button mat-button color="lightGreen" (click)="generatePreview()" [disabled]="disableGeneratePreview()">Generate Preview</button>
            </div>

        </form>
    </div>
    <div class="result-container">
        <div class="container" *ngIf="results">
            <div>
                <strong>SUBJECT:</strong> {{results.subject}}
            </div>
            <div>
                <img src="https://oma-lighthouse-staging.s3.us-east-1.amazonaws.com/accounts/98/images/Graton-Resort-Casino-2-450x250-1.png" alt="Graton Resort Casino" width="250" />
            </div>
            <div [innerHTML]="results.body"></div>
        </div>
    </div>
</div>